// extracted by mini-css-extract-plugin
export default {"scope":"zLOe7","dropzone":"XCICl","dropzone--is-disabled":"U1FO-","overlay":"EJT22","dropzone--is-active":"I4y0A","uploader":"ZTL2I","select":"PHfMa","input":"lp51P"};